<template>
	<b-modal
		id="modal-editCertificado"
		size="lg"
		@show="resetModal"
		@ok="handleEnvio"
	>
		<template v-slot:modal-title>
			<label>Edicion certificacion</label>
		</template>
		<b-alert show variant="warning">
			No olvides estar seguro al realizar cualquier cambio en el certificado.
		</b-alert>
		<b-form-group label="Nombre Certificado">
			<b-form-input
				v-model="certificado.nombre"
				placeholder="Ingresa el nombre del certificado..."
			>
			</b-form-input>
			<span v-if="error.nombre" style="color:red">{{ error.nombre }}</span>
		</b-form-group>
		<b-form-group label="Contenido Certificado">
			<ckeditor v-model="certificado.contenido"></ckeditor>
			<span v-if="error.contenido" style="color:red">
				{{ error.contenido }}
			</span>
		</b-form-group>
		<b-form-group label="Imagen Cabecera">
			<a :href="certificado.urlHeader" target="_blank">Link actual cabecera</a>
			<b-form-file
				v-model="certificado.imgCabecera"
				placeholder="Arrastra tu archivo hasta aquí..."
				drop-placeholder="Busca tu archivo..."
			></b-form-file>
			<br />
			<small>El archivo no puede superar los 200mb. </small>
			<span v-if="error.imgCabecera" style="color:red">
				{{ error.imgCabecera }}
			</span>
		</b-form-group>
		<b-form-group label="Imagen Pie Pagina">
			<a :href="certificado.urlFooter" target="_blank">Link actual pie pagina</a>
			<b-form-file
				v-model="certificado.imgPiePagina"
				placeholder="Arrastra tu archivo hasta aquí..."
				drop-placeholder="Busca tu archivo..."
			></b-form-file>
			<br />
			<small>El archivo no puede superar los 200mb. </small>
			<span v-if="error.imgPiePagina" style="color:red">
				{{ error.imgPiePagina }}
			</span>
		</b-form-group>
		<toast ref="toast" />
		<template v-slot:modal-footer="{ ok, cancel }">
			<b-button @click="cancel()">
				Cancelar
			</b-button>
			<b-button  v-if="load != true" variant="primary" @click="ok()">
				Aceptar
			</b-button>
				<b-button v-else variant="primary">
				<b-spinner small type="grow"></b-spinner>
				Cargando por favor espere...
			</b-button>
		</template>
	</b-modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import toast from "@/components/toastComponent";
export default {
	components: {
		toast
	},
	data() {
		return {
			load: false,
			listadoCurso: [],
			listadoFinal: [],
			error: {
				idCurso: "",
				nombre: "",
				contenido: "",
				imgCabecera: "",
				imgPiePagina: ""
			},
			certificado: {
				idCerificado: null,
				nombre: null,
				contenido: null,
				imgCabecera: null,
				imgPiePagina: null
			}
		};
	},
	computed: {
		...mapState("certificado", ["jsonCertificado"]),
		...mapState("certificado", ["jsonInstanciaCertificado"]),
		...mapState("curso", ["jsonCurso"])
	},
	methods: {
		handleEnvio(bvModalEvt) {
			// Prevent modal from closing
			bvModalEvt.preventDefault();

			const valorCampos = this.camposVacios();
			if (valorCampos) {
				this.load = true;
				this.updateAlumno();
			}
		},
		updateAlumno() {
			var form = new FormData();
			form.append("idCertificado", this.certificado.idCertificado);
			form.append("nombreCertificado", this.certificado.nombre);
			form.append("contenido", this.certificado.contenido);
			form.append("imgCabecera", this.certificado.imgCabecera);
			form.append("imgPiePagina", this.certificado.imgPiePagina);

			this.axios
				.post("api/updateCertificado", form)
				.then(res => {
					this.load = false;
					if (res.data.msg == "cerificadoActualizado") {
						this.error = {
							nombre: "",
							contenido: ""
						};

						const arrayToast = {
							msg: "Se ha actualizado el certificado con exito",
							title: "Exito",
							variant: "success"
						};

						this.$refs.toast.makeToast(arrayToast);

						const certificado = this.jsonCertificado.find(
							elem => elem.idCertificado == this.certificado.idCertificado
						);
						certificado.nombreCertificado = this.certificado.nombre;
						certificado.contenido = this.certificado.contenido;
					}
				})
				.catch(err => console.log(err));
		},
		getInfoModal(arrayOpcion) {
			// console.log(arrayOpcion);

			this.certificado.idCertificado = arrayOpcion.idCertificado;
			this.certificado.nombre = arrayOpcion.nombreCertificado;
			this.certificado.contenido = arrayOpcion.contenido;
			this.certificado.urlHeader = arrayOpcion.urlHeader;
			this.certificado.urlFooter = arrayOpcion.urlFooter;
		},
		camposVacios() {
			var booleanEstado = true;
			if (!this.certificado.nombre) {
				this.error.nombre = "Este campo es obligatorio";
				booleanEstado = false;
			}
			if (!this.certificado.contenido) {
				this.error.contenido = "Este campo es obligatorio";
				booleanEstado = false;
			}

			return booleanEstado;
		},
		resetModal() {
			this.listadoFinal = [];
			this.error = {
				nombre: "",
				contenido: ""
			};
		}
	}
};
</script>
